import React from "react";

const IconFind = ({ color = "#333", height = "33", width = "33" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71875 14.25C11.3259 14.25 14.25 11.3259 14.25 7.71875C14.25 4.11164 11.3259 1.1875 7.71875 1.1875C4.11164 1.1875 1.1875 4.11164 1.1875 7.71875C1.1875 11.3259 4.11164 14.25 7.71875 14.25ZM15.4375 7.71875C15.4375 11.9817 11.9817 15.4375 7.71875 15.4375C3.4558 15.4375 0 11.9817 0 7.71875C0 3.4558 3.4558 0 7.71875 0C11.9817 0 15.4375 3.4558 15.4375 7.71875Z"
        fill={color}
      />
      <path
        d="M12.2834 13.9438C12.3184 13.9913 12.3574 14.0368 12.4004 14.0798L16.9728 18.6522C17.4366 19.1159 18.1884 19.1159 18.6522 18.6522C19.1159 18.1884 19.1159 17.4366 18.6522 16.9728L14.0798 12.4004C14.0368 12.3574 13.9913 12.3184 13.9438 12.2834C13.478 12.9176 12.9176 13.478 12.2834 13.9438Z"
        fill={color}
      />
    </svg>
  );
};

export default IconFind;
